import { CategoryResult } from './category-result.model';

export class CirilCategoryResult {
  constructor(public algorithmicThinking: CategoryResult) {}
}
